import { Section, CodeWrapper, UsefulLinksWrapper, UsefulLink } from 'nca-acquiring-theme';
import { enableCloudWatchSnippet, setCloudWatchNamespaceSnippet, setCloudWatchIntervalSnippet } from "../../../../src/snippets/AwsMetricsSnippets";
import * as React from 'react';
export default {
  Section,
  CodeWrapper,
  UsefulLinksWrapper,
  UsefulLink,
  enableCloudWatchSnippet,
  setCloudWatchNamespaceSnippet,
  setCloudWatchIntervalSnippet,
  React
};